export default "__VITE_ASSET__aba1d880__"